import ISaleComp from "../interfaces/ISaleComp";
import useFocusShape from "./useFocusShape";
import useSaleCompsInsideShape from "./useSaleCompsInsideShape";

export default function (saleComps: ISaleComp[]): ISaleComp[] {
    return useSaleCompsInsideShape(saleComps, useFocusShape());
}